import { faArrowRight } from '@fortawesome/pro-regular-svg-icons'
import { Card, IllustrationBlock, Link, Text } from '@/ui'
import { ImageBackgroundColors, mtc, TypographyStyles } from '@/styles'

/**
 * Shown on the post-intake surfaces (report, consult, waitlist, disqualified).
 * Points at the resource hub rather than asking for a subscription: submitting
 * the report already subscribes them, so a sign-up ask reads as a dead end.
 */
export const KeepInTouchCard = ({ className }: { className?: string }) => {
  return (
    <Card className={mtc('w-full mx-4', className)}>
      <IllustrationBlock
        src="https://heard-images.s3.amazonaws.com/assets/books.svg"
        alt="books"
        size="sm"
        color={ImageBackgroundColors.GREEN}
        className="-mt-6 -ml-6 w-[calc(100%+48px)] rounded-b-none"
      />
      <Text variant={TypographyStyles.H3} className="mt-6">
        Keep learning
      </Text>

      <Text variant={TypographyStyles.BODY_SM} className="mt-1">
        Our resource hub is a free library of guides on running a private
        practice: taxes, bookkeeping, entities, and getting paid, written for
        therapists rather than for accountants.
      </Text>

      <div className="mt-3">
        <Link
          href="https://www.joinheard.com/resources"
          iconRight={faArrowRight}
          newPage
        >
          Explore Resource Hub
        </Link>
      </div>
    </Card>
  )
}
